var path = 'src/app/patients/fetal-anomaly-scans/fetal-anomaly-scans.html';
var html = "<h1 class=page-header>Fetal Anomaly Scans</h1> <div fetal-anomaly-scans-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/fetal-anomaly-scans/fetal-anomaly-scans.html
 ** module id = 453
 ** module chunks = 0
 **/